var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHibrido(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.084,
    height: 12.18,
    viewBox: "0 0 10.084 12.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10773",
    "data-name": "Trazado 10773",
    d: "M38.454,25.146c.02.127-.054.245-.154.245h-.345a.174.174,0,0,1-.154-.162l-.29-1.827c-.02-.127.054-.245.155-.245h.345a.172.172,0,0,1,.152.163Zm-7.679-7.97a1.483,1.483,0,0,1,.6.367,1.467,1.467,0,0,1,.431,1.041v1.1a.262.262,0,0,0,.262.262h4.7a.263.263,0,0,0,.262-.262v-1.1a1.483,1.483,0,0,1,1.034-1.408.26.26,0,0,0,.181-.249V14.353a1.146,1.146,0,0,0-1.14-1.142H31.735a1.146,1.146,0,0,0-1.142,1.142v2.575a.261.261,0,0,0,.182.249m.429,5.981h-.39a.15.15,0,0,0-.132.141l-.3,1.882a.165.165,0,0,0,.132.21H30.9a.148.148,0,0,0,.134-.141l.3-1.881c.016-.109-.048-.212-.134-.212m-1.673-3.215h1.609a.149.149,0,0,0,.149-.151V18.584a.955.955,0,0,0-1.911,0v1.208a.151.151,0,0,0,.152.151m8.977-2.315a.959.959,0,0,0-.955.955v1.2a.156.156,0,0,0,.156.155l.906,0,.694,0a.154.154,0,0,0,.155-.155v-1.2a.956.956,0,0,0-.955-.955m.748,2.834H31.55l-.923-.006-1.041,0a.208.208,0,0,0-.208.21v.923a1.046,1.046,0,0,0,1.045,1.045h8a1.048,1.048,0,0,0,.738-.307l.011-.013a1.039,1.039,0,0,0,.294-.725v-.923a.209.209,0,0,0-.208-.209",
    transform: "translate(-29.379 -13.211)",
    fill: "#64c5dd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibrido);
export default __webpack_public_path__ + "static/media/hibrido.3971317c6309081b23a5bc8b90415fcf.svg";
export { ForwardRef as ReactComponent };